export const PmtMethodEnum = {
  ACH: 'ACH',
  CHECK: 'CHECK',
  EFS: 'EFS',
  WIRE: 'WIRE',
  FACTORED: 'FACTORED',
};

export const pmtMethod = {
  ACH: 'Ach',
  CHECK: 'Check',
  EFS: 'EFS',
  WIRE: 'WIRE',
  FACTORED: 'Factored',
};

export const pmtMethodList = [
  {
    id: PmtMethodEnum.ACH,
    name: pmtMethod.ACH,
  },

  {
    id: PmtMethodEnum.CHECK,
    name: pmtMethod.CHECK,
  },

  {
    id: PmtMethodEnum.EFS,
    name: pmtMethod.EFS,
  },

  {
    id: PmtMethodEnum.WIRE,
    name: pmtMethod.WIRE,
  },

  {
    id: PmtMethodEnum.FACTORED,
    name: pmtMethod.FACTORED,
  },
];

export const PmtTermEnum = {
  'CUSTOM_QUICKPAY': 'CUSTOM_QUICKPAY',
  'THIRTYDAY': 'THIRTYDAY',
  'QUICKPAY': 'QUICKPAY',
};

export const pmtTerm = {
  'CUSTOM_QUICKPAY': 'Custom Quick pay',
  'THIRTYDAY': 'Thirtyday',
  'QUICKPAY': 'Quickpay',
};


export const pmtTermList = [
  {
    id: PmtTermEnum.CUSTOM_QUICKPAY,
    name: pmtTerm.CUSTOM_QUICKPAY,
  },

  {
    id: PmtTermEnum.THIRTYDAY,
    name: pmtTerm.THIRTYDAY,
  },

  {
    id: PmtTermEnum.QUICKPAY,
    name: pmtTerm.QUICKPAY,
  },
];

export const PayableStatusEnum = {
  NOTPAYABLE: 'NOTPAYABLE',
  PAYABLE: 'PAYABLE',
  PENDING_PAYABLE: 'PENDING_PAYABLE',
  PMT_VERIFICATION: 'PMT_VERIFICATION',
  PAID: 'PAID',
  CLOSED: 'CLOSED',
};